<template>
  <AdminModal
    :is-open="isOpen"
    modalSize="sm"
    :modal-title="`기간 연장`"
    :confirm="update"
    :close="close"
    confirmButtonTitle="저장"
    name="extendExpiredAtModal"
  >
    <b-container>
      <b-row>
        <b-col>
          <b-form-floating-label>
            연장일자
          </b-form-floating-label>
          <b-form-select v-model="selectedExtendDays">
            <b-form-select-option v-for="extendDay in extendDays" :key="extendDay" :value="extendDay">
              {{extendDay}}
            </b-form-select-option>
          </b-form-select>
        </b-col>
      </b-row>
    </b-container>
  </AdminModal>
</template>
<script>
import AdminModal from "@/components/modals/AdminModal.vue";
import api from "@/api/api";

export default {
  name: "ExtendExpiredAtModal",
  components: {AdminModal},
  props: ['isOpen', 'lessonAccess', 'reload', 'close'],
  data() {
    return {
      selectedExtendDays: 1,
      extendDays: Array.from({length: 30}, (_, i) => i + 1)
    }
  },
  methods: {
    update() {
      api.lessonAccesses.extendExpiredAt({
        manageCode: this.lessonAccess.manageCode,
        extendDays: this.selectedExtendDays
      }, _ => {
        this.$toast.show( `${this.lessonAccess.manageCode}의 수강일이 연장되었습니다.`,
          {
            position: "top-right",
            duration: 2000
          })
        this.reload()
        this.close()
      })
    }
  }
}
</script>

<style scoped>

</style>